module.exports = __webpack_public_path__ + "img/ico-email.701d423d.svg";